import { IBriefCampaignBriefInfluencer } from "@shared/lib/types/briefCampains";
import {
  IBrandCostRequest,
  IBriefInfluencerV2,
  IInfluencerCostRequest,
} from "@shared/lib/types/briefInfluencerV2";
import { usePopoverInputNumberFocus } from "@shared/lib/utils/focusPopoverInput";
import { Card } from "@shared/ui";
import { Button } from "@shared/ui/Button";
import { InputNumber } from "@shared/ui/InputNumber";
import { Flex, Form } from "antd";
import styles from "./styles.module.scss";

export function AddCommercials({
  initialValues,
  onClose,
  handleSave,
  isLoading,
  briefInfluencer,
  type,
  isViewOnly = false,
}: {
  initialValues: Partial<{
    cost: number;
    note: string;
  }>;

  onClose: () => void;
  handleSave: (
    values:
      | Omit<IInfluencerCostRequest, "briefInfluencerId">
      | Omit<IBrandCostRequest, "briefInfluencerId">
  ) => void;
  isLoading: boolean;
  type: "influencer" | "brand";
  briefInfluencer: IBriefInfluencerV2 | IBriefCampaignBriefInfluencer;
  isViewOnly?: boolean;
}) {
  const [form] = Form.useForm();
  const costInputRef = usePopoverInputNumberFocus();

  const isPricingPocAssigned = Boolean(
    briefInfluencer?.assignedPricingPocV2?.assignedToUserId
  );

  const cost = Form.useWatch("cost", form);

  const revenue = (cost || 0) - (briefInfluencer?.influencerCost?.cost || 0);

  const revenuePercentage = (
    (((cost || 0) - (briefInfluencer?.influencerCost?.cost || 0)) /
      (cost || 1)) *
    100
  ).toFixed(2);

  // useEffect(() => {
  //   if (initialValues) {
  //     form.setFieldsValue(initialValues);
  //   }
  // }, [initialValues]);

  return (
    <Form
      form={form}
      className={styles.commercialsForm}
      layout="vertical"
      onFinish={(values) => {
        handleSave({ cost: Number(values.cost) });
      }}
      initialValues={initialValues}
      disabled={isViewOnly}
      requiredMark={false}
    >
      <Form.Item
        name="cost"
        rules={[{ required: true, message: "Please enter the commercials" }]}
      >
        <div ref={costInputRef}>
          <InputNumber
            placeholder="100"
            style={{ width: "100%" }}
            prefix={"₹"}
            type="number"
            min={0}
          />
        </div>
      </Form.Item>

      {type === "brand" && (
        <Card
          style={{
            marginTop: -2,
            backgroundColor: "#f8fafc",
            border: "1px solid #e3e8ee",
          }}
          styles={{
            body: {
              padding: 10,
            },
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{
              fontSize: 11,
              color: "#697386",
            }}
          >
            <span>
              Influencer Commercial:{" "}
              <b> ₹{briefInfluencer?.influencerCost?.cost || "0"} </b>
            </span>
            <span>
              Revenue: <b> ₹{revenue} </b>
            </span>
            <span>
              Revenue %: <b> {revenuePercentage}% </b>
            </span>
          </Flex>
        </Card>
      )}

      <Flex justify="end" gap={4} style={{ marginTop: 10 }}>
        <Button onClick={onClose} disabled={false} size="small" type="text">
          Cancel
        </Button>
        {!isViewOnly && (
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            disabled={!isPricingPocAssigned && type === "influencer"}
            size="small"
          >
            Save
          </Button>
        )}
      </Flex>
    </Form>
  );
}
